import React from 'react';
import { FadeIn } from './FadeIn';
export function ProofSection() {
  return <section className="bg-cream py-6 px-4 md:px-8" data-id="element-164">
      <div className="max-w-2xl mx-auto" data-id="element-165">
        <FadeIn data-id="element-166">
          <div className="bg-white rounded-xl p-4 md:p-6 shadow-md border-l-4 border-gold" data-id="element-167">
            <h2 className="text-xl md:text-2xl font-bold text-forest mb-2" data-id="element-168">
              What changes in 14 days?
            </h2>

            <div className="space-y-2 text-sm md:text-base text-charcoal leading-relaxed" data-id="element-169">
              <p data-id="element-170">
                By shifting your "chemical inputs," the fluid in your joints
                thins.
              </p>
              <p className="font-medium text-forest text-base md:text-lg italic" data-id="element-171">
                Most women report that the "10-minute morning fog" disappears,
                grip strength improves, and that 3:00 PM "heavy limb" feeling is
                replaced by steady, natural energy.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}